import { useContext } from "react"

// components
import { Container, Paper, Grid, IconButton } from "@material-ui/core"
import { LoadingBig } from "../../shared/Loading/LoadingBig"
import AddIcon from "@material-ui/icons/Add"
import { HitterTable } from "./HitterTable/HitterTable"

// contexts
import { GlobalsContext } from "../../context/GlobalsContext"
import { HittingPageContext } from "./HittingPage"

export const InactiveTab = () => {
	const { user } = useContext(GlobalsContext)
	const { loading, players, openNewHitterModal } =
		useContext(HittingPageContext)

	if (loading) {
		return <LoadingBig />
	}

	return (
		<Container className="tab-container">
			<Grid spacing={0} container component={Paper}>
				<Grid item xs={9} className="pitching-roster-table-title">
					<span>Inactive Hitters</span>
				</Grid>
				{user!.admin && (
					<Grid item xs={3} className="pitching-roster-table-add">
						<IconButton onClick={openNewHitterModal}>
							<AddIcon />
						</IconButton>
					</Grid>
				)}
				<Grid item xs={12}>
					<HitterTable
						players={players.filter(
							(player) => !player.active && player.batter
						)}
					/>
				</Grid>
			</Grid>
		</Container>
	)
}
